import React,{ useEffect, useState } from 'react';
const AddNoodle = ({formValues, handleAddNoodle}) => {
  
  return (
    <div className="checkbox-container">
        <label className="checkbox-label">
            <input
            type="checkbox"
            className="checkbox-input"
            checked={formValues.Noodle}
            onChange={handleAddNoodle}
            />
            加麵
        </label>
    </div>

  );
};

export default AddNoodle;
